<!-- Localized -->
<template>
  <div
    class="neo-dropdown"
    :style="customStyles"
    v-on-click-outside="clickOutside" 
  >
    <div
      :class="['neo-dropdown__trigger flex items-center gap-x-2', triggerClass]"
      :style="triggerStyles"
      ref="dropdown"
    >
      <div class="flex gap-2 items-center" @click.stop="handleOpen('area')">
        <div>
            <slot name="drop-trigger" />
        </div>
        <div class="flex flex-col gap-2.5 item-center">
            <slot name="drop-trigger-before"/>
            <font-awesome-icon
                v-if="!disabled"
                @click.stop="handleOpen('arrow')"
                :icon="isDropdownActive ? 'chevron-down' : 'chevron-down'"
                class="transition-all cursor-pointer"
            />
        </div>
      </div>
    </div>
    <div
      v-if="isDropdownActive"
      class="neo-dropdown__list bg-white list-none p-0 flex flex-col items-start rounded-b-2xl shadow-lg overflow-hidden"
      :style="listStyles"
      ref="list"
    >
        <slot name="drop-content" />
    </div>
  </div>
</template>

<script>
export default {
    name: "neo-dropdown",
    props: {
        disableAreaTrigger: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placement: {
            type: String,
            default: 'left',
        },
        triggerClass: {
            type: String,
            default: '',
        },
        triggerStyles: {
            type: [String, Object],
            default: '',
        },
        listStyles: {
            type: [String, Object],
            default: '',
        },
        customStyles: {
            type: [String, Object],
            default: "",
        },
        minWidth: {
            type: Number,
            default: 240,
        }
    },

    data() {
        return {
            isDropdownActive: false
        }
    },

    watch: {
        isDropdownActive(val) {
            if (val) this.placeDropdown()
        }
    },
    computed: {
        
    },

    methods: {
        clickOutside() {
            this.isDropdownActive = false;
            this.$emit('onOpen', this.isDropdownActive);
        },
        handleOpen(clickZone) {
            if (this.disabled || this.disableAreaTrigger && clickZone == 'area') return;
            this.isDropdownActive = !this.isDropdownActive
            this.$emit('onOpen', this.isDropdownActive);
        },
        openTop() {
            const listRectangle = this.$refs.list.getBoundingClientRect();
            return  listRectangle.bottom >= window.innerHeight;
        },
        placeDropdown() {
            if (this.isDropdownActive) {
                 this.$nextTick(() => {
                    let { top, bottom, width, left, right } = this.$el.getBoundingClientRect();
                    const container = this.$refs.dropdown;
                    const listEl = this.$refs.list;
                    if (container && listEl) {
                        container.style.width = "100%";
                        // Set dropdown list to auto width but at least as wide as the trigger
                        listEl.style.width = "auto";
                        listEl.style.minWidth = `${this.minWidth || width}px`;
                        if (this.placement == 'right') {
                            left = right - this.minWidth;
                        }
                        listEl.style.left = `${left}px`;
                        listEl.style.top = 'auto';
                        if (this.openTop()) {
                            const listHeight = listEl.getBoundingClientRect().height;
                            listEl.style.top = `${top - listHeight}px`;
                        } else {
                            listEl.style.top = `${bottom}px`;
                        }
                    }
                });
            }
        }
    },
    created() {
        document.addEventListener("scroll", this.placeDropdown, true);
        window.addEventListener("resize", this.placeDropdown);
    },
    destroyed() {
        document.removeEventListener("scroll", this.placeDropdown, true);
        window.removeEventListener("resize", this.placeDropdown);
    }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/functions.scss';
.neo-dropdown {
    height: 100% !important;
}
.neo-dropdown__list {
    position: fixed;
    z-index: 1000;
    color: grey;
}

.neo-dropdown__list--option:hover {
    background-color: #cce3ff;
    cursor: pointer;
}
</style>
